import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { CrudlStatus } from "../../../common/config/AppConstants";
import { BPMInput } from "../../Common/BPMInput";
import * as format from "../../../common/FormatFunctions";
import { ListValueGenerator } from "../../Common/ListValueGenerator";
import { LoadScreen } from "../../Common/LoadScreen";
export class SiteCard extends React.Component {
  render() {
    return (
      <React.Fragment>
        <pr.ScrollPanel
          ref={el => (this.layoutMenuScroller = el)}
          style={{ height: "85%", borderColor: "transparent" }}
        >
          <div className="ui-g">
            <h2>
              {format.capitalize(this.props.crudlState.display) + " Site"}
            </h2>
            <div className="ui-g-12"></div>
            {this.props.loading === true && <LoadScreen />}
            {this.props.loading !== true && (
              <React.Fragment>
                <div className="ui-g-1"></div>
                <div className="ui-g-5">
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Name *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.name}
                        onChange={e =>
                          this.props.updateValue("name", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Address Line 1 *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.addressLine1}
                        onChange={e =>
                          this.props.updateValue("addressLine1", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Address Line 2 </label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.addressLine2}
                        onChange={e =>
                          this.props.updateValue("addressLine2", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">City </label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.city}
                        onChange={e =>
                          this.props.updateValue("city", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Postcode * </label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.postcode}
                        onChange={e =>
                          this.props.updateValue("postcode", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                </div>
                <div className="ui-g-5">
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Contact Email </label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.email}
                        onChange={e =>
                          this.props.updateValue("email", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Contact Telephone</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.telephone}
                        onChange={e =>
                          this.props.updateValue("telephone", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                </div>
                <div className="ui-g-1"></div>
                <div className="ui-g-1"></div>
                <div className="ui-g-10">
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Buildings</label>
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <pr.DataView
                      ref={el => {
                        this.dt = el;
                      }}
                      reorderableColumns={false}
                      selectionMode="single"
                      onSelectionChange={e => {}}
                      value={this.props.editedObject.buildingRequestList}
                      // expandedRows={this.props.buildingExpandedRows}
                      // onRowToggle={e =>
                      //   this.props.updateState("buildingExpandedRows", e.data)
                      // }
                      header={
                        <div className="ui-g">
                          <div className="ui-g-12">
                            <pr.Button
                              className="secondary-btn"
                              icon="pi pi-plus"
                              label={"Add Building"}
                              onClick={e => {
                                this.props.addBuilding();
                              }}
                              style={{ float: "right" }}
                            />
                          </div>
                        </div>
                      }
                      itemTemplate={this.getBuildingSelectionView}
                      dataKey="id"
                      emptyMessage="No Properties"
                      rows={100}
                      autoLayout={true}
                      style={{ borderColor: "transparent" }}
                    >
                      {/* <pr.Column
                        key="expander"
                        expander={true}
                        style={{ width: "5em", float: "middle" }}
                      />
                      <pr.Column
                        field="name"
                        header="Name"
                        editor={this.buildingNameEditor}
                        sortable={true}
                        style={{ overflow: "auto" }}
                      ></pr.Column>

                      <pr.Column
                        field="description"
                        header="Description"
                        editor={this.buildingDescriptionEditor}
                        sortable={true}
                        style={{ overflow: "auto" }}
                      ></pr.Column>
                      <pr.Column
                        key="add"
                        body={this.getBuildingRemoveTemplate}
                        style={{ textAlign: "center", width: "8em" }}
                        header={
                          <div className="ui-g">
                            <div className="ui-g-12">
                              <pr.Button
                                className="secondary-btn"
                                icon="pi pi-plus"
                                onClick={e => {
                                  this.props.addBuilding();
                                }}
                                style={{}}
                              />
                            </div>
                          </div>
                        }
                      /> */}
                    </pr.DataView>
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        </pr.ScrollPanel>

        <div className="Container">
          <pr.Toolbar
            className="bottom-bar"
            style={{
              backgroundColor: "transparent",
              borderColor: "transparent"
            }}
          >
            <div className="p-toolbar-group-left">
              <pr.Button
                icon="pi pi-times"
                label={"Cancel"}
                className="p-button-danger"
                style={{
                  marginRight: ".25em",
                  float: "left",
                  backgroundColor: "#043066"
                }}
                onClick={() => {
                  this.props.validateChanges();
                }}
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-trash"
                }
                label={"Delete"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.DELETE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState !== CrudlStatus.CREATE &&
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save"}
                onClick={e => {
                  this.props.crudlExecute(true);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save and Close"}
                onClick={() => {
                  this.props.crudlExecute(false);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-pencil"
                }
                label={"Edit"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.UPDATE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState === CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
            </div>
          </pr.Toolbar>
        </div>
      </React.Fragment>
    );
  }
  buildingNameEditor = props => {
    return this.buildingNameInputTextEditor(props, "name");
  };
  buildingNameInputTextEditor = (props, field) => {
    return (
      <pr.InputText
        type="text"
        value={props.rowData[field] || ""}
        onChange={e =>
          this.onBuildingEditorValueChange(
            props.rowIndex,
            props.field,
            e.target.value
          )
        }
      />
    );
  };
  onBuildingEditorValueChange = (buildingBean, field, value) => {
    let updatedList = this.props.editedObject.buildingRequestList;
    updatedList.forEach(building => {
      if (buildingBean.id === building.id) {
        building[field] = value;
      }
    });

    this.props.updateValue("buildingRequestList", updatedList);
  };
  buildingDescriptionEditor = props => {
    return this.buildingDescriptionInputTextEditor(props, "description");
  };
  buildingDescriptionInputTextEditor = (props, field) => {
    return (
      <pr.InputText
        type="text"
        value={props.rowData[field] || ""}
        onChange={e =>
          this.onBuildingEditorValueChange(
            props.rowIndex,
            props.field,
            e.target.value
          )
        }
      />
    );
  };
  getBuildingRemoveTemplate = (rowData, column) => {
    return (
      <div>
        <pr.Button
          type="button"
          icon="pi pi-trash"
          className="p-button-success"
          onClick={e => {
            this.props.removeBuilding(rowData);
          }}
          style={{ marginRight: ".5em" }}
        ></pr.Button>
      </div>
    );
  };

  getBuildingSelectionView = data => {
    return (
      <div className="ui-g-12">
        <div className="ui-g-6">
          <div className="ui-g-12">
            <div className="ui-g-3">
              <label className="input-label">Name *</label>
            </div>
            <div className="ui-g-9">
              <pr.InputText
                type="text"
                value={data.name || ""}
                onChange={e =>
                  this.onBuildingEditorValueChange(data, "name", e.target.value)
                }
              />
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-3">
              <label className="input-label">Description *</label>
            </div>
            <div className="ui-g-9">
              <pr.InputText
                type="text"
                value={data.description || ""}
                onChange={e =>
                  this.onBuildingEditorValueChange(
                    data,
                    "description",
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        </div>
        <div className="ui-g-6">
          <div className="ui-g-3">
            <label className="input-label">Locations</label>
          </div>

          <div className="ui-g-12">{this.getLocationSelectionView(data)}</div>
          <div className="ui-g-12">
            <div className="ui-g">
              <div className="ui-g-12">
                <pr.Button
                  type="button"
                  icon="pi pi-trash"
                  label={"Delete Building"}
                  className="p-button-success"
                  onClick={e => {
                    this.props.removeBuilding(data);
                  }}
                  style={{ marginRight: ".5em", float: "right" }}
                ></pr.Button>
                <pr.Button
                  icon="pi pi-plus"
                  label={"Add Location"}
                  className="p-button-success"
                  onClick={e => {
                    this.props.addLocation(data);
                  }}
                  style={{ float: "right" }}
                />
              </div>
            </div>
          </div>
        </div>
        <hr></hr>
      </div>
    );
  };
  getLocationSelectionView = data => {
    return (
      <div
        style={{
          width: "100%",
          objectFit: "contain",
          height: "200px",
          marginTop: "18px",
          border: "1px solid lightgrey",
          overflowY: "scroll"
        }}
      >
        {this.getLocationViews(data)}
      </div>
    );
  };

  getLocationViews = data => {
    var componentArray = [];
    var index = 0;
    if (format.isNotNull(data.locationRequestList)) {
      data.locationRequestList.forEach(element => {
        componentArray[index] = (
          <React.Fragment>
            {this.getLocationView(data.id, index, element)}
          </React.Fragment>
        );
        index++;
      });
    }
    return componentArray;
  };
  getLocationView = (buildingId, index, data) => {
    return (
      <div className="ui-g-12">
        <div className="ui-g-12">
          <div className="ui-g-3">
            <label className="input-label">Name *</label>
          </div>
          <div className="ui-g-9">
            <pr.InputText
              type="text"
              value={data.name || ""}
              onChange={e =>
                this.onLocationEditorValueChange(
                  buildingId,
                  index,
                  data,
                  "name",
                  e.target.value
                )
              }
            />
          </div>
        </div>
        <div className="ui-g-12">
          <div className="ui-g-3">
            <label className="input-label">Description *</label>
          </div>
          <div className="ui-g-9">
            <pr.InputText
              type="text"
              value={data.description || ""}
              onChange={e =>
                this.onLocationEditorValueChange(
                  buildingId,
                  index,
                  data,
                  "description",
                  e.target.value
                )
              }
            />
          </div>
        </div>
        {/* <div className="ui-g-12">
          <div className="ui-g-3">
            <label className="input-label">Floor *</label>
          </div>
          <div className="ui-g-9">
            <pr.InputText
              type="text"
              value={data.floor || ""}
              onChange={e =>
                this.onLocationEditorValueChange(
                  buildingId,
                  index,
                  data,
                  "floor",
                  e.target.value
                )
              }
            />
          </div>
        </div> */}
        <div className="ui-g-12">
          <pr.Button
            type="button"
            icon="pi pi-trash"
            label={"Delete Location"}
            className="p-button-success"
            onClick={e => {
              this.props.removeLocation(data);
            }}
            style={{ marginRight: ".5em", float: "right" }}
          ></pr.Button>
        </div>
        <hr></hr>
      </div>
    );
  };
  onLocationEditorValueChange = (
    buildingId,
    index,
    locationBean,
    field,
    value
  ) => {
    let updatedList = this.props.editedObject.buildingRequestList;
    console.log(locationBean);
    updatedList.forEach(element => {
      if (element.id === buildingId) {
        element.locationRequestList[index][field] = value;
      }
    });

    this.props.updateValue("buildingRequestList", updatedList);
  };
}



// WEBPACK FOOTER //
// ./src/components/Sites/UI/SiteCard.js